import { Component } from '@angular/core';

@Component({
  selector: 'page-mysport-routes',
  templateUrl: 'mysport-routes.html'
})
export class MysportRoutesPage {
  constructor() { }
}



// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-routes/mysport-routes.ts